export function lang(intl, id) {
  return intl.formatMessage({ id });
}
